import { render, staticRenderFns } from "./NicolazziLogo.vue?vue&type=template&id=6141302f&scoped=true&"
var script = {}
import style0 from "./NicolazziLogo.vue?vue&type=style&index=0&id=6141302f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141302f",
  null
  
)

export default component.exports